<template>
  <v-toolbar flat class="mb-4">
    <v-toolbar-title>
      {{ $t("alarms.title") }}
      <span></span>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <div>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            class="mx-2"
            color="accent darken-3"
            fab
            small
            router
            to="/alarms/actives"
            v-on="on"
          >
            <v-icon dark>mdi-bell-ring</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("routes.alarmActive") }}</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            class="mx-2"
            color="accent"
            fab
            small
            router
            to="/alarms"
            v-on="on"
          >
            <v-icon dark>mdi-alarm</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("alarms.title") }}</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }" v-if="permitted('Alarms.Create')">
          <v-btn
            class="mx-2"
            fab
            small
            color="primary"
            router
            to="/alarms/create"
            v-on="on"
          >
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("alarms.create") }}</span>
      </v-tooltip>
    </div>
  </v-toolbar>
</template>

<script>
export default {
  name: "AlarmToolbar",
};
</script>